<script setup>
import { onMounted, ref, reactive } from 'vue'
import { useUserStore } from '@/stores/userStore'
import { useRouter } from 'vue-router'
import { getbrowseListAPI, getOrder_countAPI } from '@/apis/user'
import GoodsItem from '@/views/Home/components/GoodsItem.vue'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
const router = useRouter()
const userStore = useUserStore()
const dialogVisible = ref(false)
const goPage = (url) => {
    router.push(url)
}
const toPublish = () => {
    if (userStore.userInfo.sellerType == 2) { dialogVisible.value = true } else {
        goPage('/publish')
    }
}
const currentRoute = ref(router.currentRoute.value.path);
const isMobile = ref(false);//false代表pc
// 监听路由变化
watch(
    () => router.currentRoute.value.path,
    (newPath) => {
        currentRoute.value = newPath;
    }
);
const likeList = ref([])
const reqData = ref({
    name: '',
    page: 1,
    pageSize: 20,
})
const total = ref()
const getLikeList = async () => {
    const res = await getbrowseListAPI(reqData.value)
    if (res.code == 0) {
        likeList.value = res.data.data
        total.value = res.data.total
    }

}
const isExpanded = ref(false);

function toggleExpand() {
    isExpanded.value = !isExpanded.value;
}
// 加载更多
const disabled = ref(false)
const load = async () => {
    if (total.value > likeList.value.length) {
        // 获取下一页的数据
        reqData.value.page++;
        console.log(reqData.value)
        const res = await getbrowseListAPI(reqData.value)
        if (res.data.data == null) {
            disabled.value = true;
        } else {
            likeList.value = [...likeList.value, ...res.data.data]
        }


    }
}
const handleClose = () => {
    dialogVisible.value = false
}
const Orderparam = reactive({
    count: 0,
    third_count: 0
})
/**
 * 获取订单数
 */
const getOrder_count = async () => {
    const res = await getOrder_countAPI();
    if (res.code == 0) {
        Orderparam.count = res.data.count
        Orderparam.third_count = res.data.third_count
    }
}
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
    if (isMobile.value) {
        getLikeList()
    }
    getOrder_count();
})
</script>

<template>
    <div class="member">
        <div class="container" v-if="isMobile == false">
            <div class="xtx-member-aside">
                <div class="user-manage">
                    <div class="title">{{ $t("number1") }}</div>
                    <div class="links">
                        <RouterLink to="/member">
                            <div class="links-a">{{ $t("number2") }}</div>
                        </RouterLink>
                        <RouterLink to="/member/wallet">{{ $t("number3") }}</RouterLink>
                        <RouterLink to="/member/address">{{ $t("number28") }}</RouterLink>
                        <RouterLink to="/member/collect">{{ $t("number4") }}</RouterLink>
                        <RouterLink to="/member/focusOn">{{ $t("number5") }}</RouterLink>
                        <RouterLink to="/member/fan">{{ $t("number6") }}</RouterLink>
                        <RouterLink to="/member/history">{{ $t("number7") }}</RouterLink>
                        <RouterLink to="/member/CommonTemplate" v-if="userStore.userInfo.sellerType == 1">{{
                            $t('setup591') }}</RouterLink>
                        <RouterLink to="/member/affiliate">{{ $t("setup631") }}</RouterLink>
                    </div>
                    <div class="title">{{ $t("number8") }}</div>
                    <div class="links">
                        <RouterLink to="/member/publish">{{ $t("number9") }}</RouterLink>
                        <RouterLink to="/member/MallOrder">{{ $t("setup449") }}</RouterLink>
                        <RouterLink to="/member/PurchasingOrder">{{ $t("setup456") }}</RouterLink>
                        <RouterLink to="/member/sell">{{ $t("number11") }}</RouterLink>
                        <RouterLink to="/member/cartlist">{{ $t("number12") }}</RouterLink>
                    </div>
                </div>
            </div>
            <div class="article ">
                <!-- 三级路由的挂载点 -->
                <RouterView />
            </div>
        </div>
        <div class="container phone" v-if="currentRoute == '/member' && isMobile == true"
            style="background-color: #f8f8f8;">
            <div class="top">
                <div class="head">
                    <div class="avatar">
                        <div class="avatar-container">
                            <img :src="userStore.userInfo?.avatar || 'https://shopfile.51siteboost.com/shap-head-test/20250304/1741069084714129479.png'"
                                alt="User Avatar" class="avatar">
                        </div>
                        <div class="user">
                            <div class="name">{{ userStore.userInfo?.nickname }}</div>
                            <!-- <div class="userHome">{{ $t("number13") }}</div> -->
                            <div class="text" :class="{ expanded: isExpanded }" @click="toggleExpand">
                                {{ userStore.userInfo?.introduce }}
                            </div>
                        </div>
                    </div>
                    <div class="setup">

                        <div class="item" @click="goPage('/customerPage')"><img style="width: 18px; height: 20px;"
                                src="../../assets/images/customer.png" alt="" srcset=""></div>
                        <div class="item" @click="goPage('/setup')"><img style="width: 20px; height: 20px;"
                                src="../../assets/images/setup.png" alt="" srcset=""></div>
                    </div>
                </div>
                <div class="content">

                    <div class="item" @click="goPage('/focusOn')">

                        <div class="right">{{ userStore.userInfo?.followPersonNum }}</div>
                        <div class="title">{{ $t("number5") }}</div>
                    </div>
                    <div class="item" @click="goPage('/collect')">

                        <div class="right">{{ userStore.userInfo?.followGoodsNum }}</div>
                        <div class="title">{{ $t("number4") }}</div>
                    </div>

                    <div class="item" @click="goPage('/fan')">
                        <div class="right">{{ userStore.userInfo?.fansNum }}</div>
                        <div class="title">{{ $t("number6") }}</div>
                    </div>
                    <div class="item" @click="goPage('/wallet')">

                        <div class="right">{{ userStore.userInfo?.balance }}</div>
                        <div class="title">{{ $t("number3") }}</div>
                    </div>
                </div>
                <div class="trade">
                    <!-- <div class="title">
                <div class="title">{{ $t("number8") }}</div>
            </div> -->
                    <div class="tradecontent">
                        <!-- <div class="item" @click="goPage('/publish')"> -->
                        <div class="item" @click="toPublish">
                            <div class="img">
                                <img style="width: 23px;height: 23px;" src="../../assets/images/fabu.png" alt=""
                                    srcset="">
                            </div>
                            <div class="title">{{ $t("cart61") }}</div>

                        </div>



                        <div class="item" v-if="userStore.userInfo.sellerType == 1" @click="goPage('/member/sell')">
                            <div class="img"> <img style="width: 23px;height: 23px;" src="../../assets/images/sell.png"
                                    alt="" srcset=""></div>
                            <div class="title">{{ $t("setup454") }}</div>

                        </div>
                        <div class="item" @click="goPage('/member/PurchasingOrder')">
                            <div class="img">
                                <div class="em">{{ Orderparam.third_count }}</div> <img
                                    style="width: 23px;height: 23px;" src="../../assets/images/daigou.png" alt=""
                                    srcset="">
                            </div>
                            <div class="title">{{ $t("setup452") }}</div>

                        </div>
                        <div class="item" @click="goPage('/member/MallOrder')">
                            <div class="img">
                                <div class="em">{{ Orderparam.count }}</div> <img style="width: 23px;height: 23px;"
                                    src="../../assets/images/Mall.png" alt="" srcset="">
                            </div>
                            <div class="title">{{ $t("setup451") }}</div>

                        </div>
                        <div class="item" @click="goPage('/member/history')">
                            <div class="img"> <img style="width: 23px;height: 23px;"
                                    src="../../assets/images/history.png" alt="" srcset=""></div>
                            <div class="title">{{ $t("setup455") }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="lishi" v-if="isMobile">
                <!-- <img class="banner" @click="goPage('/member/affiliate')" src="../../assets/images/bannerb.jpg" alt="" srcset=""> -->
                <!-- <img class="banner" @click="goPage('/member/affiliate')" src="../../assets/images/affiliate-banner.jpg" alt="" srcset=""> -->
                <div class="banner-box" @click="goPage('/member/affiliate')">
                    <div style="width: calc(100% - 100px);"><div style="white-space: nowrap;">{{ $t('setup657') }}</div>
                    <div style="font-size: 12px;margin-top: 5px;color: #757373;">{{ $t('setup656') }}</div></div>
                    <img src="../../assets/images/registerbg.png" alt="" style="height: 80%;width: auto;" srcset="">
                    <!-- <svg-icon icon-class="Down" style="transform: rotate(-90deg);" /> -->

                </div>
                <div class="goods-list">
                    <div class="body" v-infinite-scroll="load" :infinite-scroll-disabled="disabled">
                        <!-- 商品列表-->
                        <GoodsItem v-for="(lick, index) in likeList" :key="index" :goods="lick" />
                    </div>

                </div>

            </div>
        </div>
        <div v-else class="container phone">
            <!-- 三级路由的挂载点 -->
            <RouterView />
        </div>
        <el-dialog v-model="dialogVisible" width="70vw" :show-close="false" :before-close="handleClose">
            <div style="text-align: center;width: 100%;">{{ $t('setup544') }}</div>
            <template #header="{ close, titleId, titleClass }">
                <div class="my-header">
                    {{ $t('setup543') }}

                </div>
            </template>
            <template #footer>
                <div class="dialog-footer" @click="dialogVisible = false">
                    <div>{{ $t('home5') }}</div>
                    <div>{{ $t('home4') }}</div>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<style scoped lang="scss">
.miandiv[data-v-34009776] {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #eff1f2;
}

.phone {
    display: none !important;
}

.pc {
    display: block;
}

.member {
    background-color: #eef0f1;
}

.container {

    display: flex;
    padding-top: 20px;
    padding-bottom: 40px;
    // height: 823px;
    // height: 100%;
    // padding-bottom: 20px;

    .xtx-member-aside {
        width: 300px;
        margin-right: 20px;
        border-radius: 2px;
        background-color: #fff;
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
        transition: box-shadow 0.2s linear;
        border-color: transparent;
        padding-bottom: 31px;
        border-radius: 8px;

        .user-manage {
            border-radius: 8px;
            background-color: #fff;

            .title {
                padding: 32px 0 17px 30px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 18px;
                color: #11192D;
                line-height: 18px;
                text-align: left;
                font-style: normal;
            }

            // h4 {
            //     font-size: 18px;
            //     font-weight: 400;
            //     padding: 20px 52px 5px;
            //     border-top: 1px solid #f6f6f6;
            // }

            // .links {
            //     padding: 0 20px 10px;
            //     color: #FFFFFF;
            // }
            // .links-a{
            //     color:#666666; 
            // }

            a {
                display: block;
                line-height: 1;
                // padding: 19px 0 0 10px;
                padding: 10px 0 10px 10px;
                // border: 1px solid;
                margin-left: 20px;
                font-size: 14px;
                color: #666;
                position: relative;
                height: 36px;
                margin-bottom: 5px;

                &:hover {
                    color: #ec4634;
                }

                &.active,
                &.router-link-exact-active {
                    width: 260px;
                    height: 36px;
                    // padding-top: 12px;
                    color: #FFFFFF;
                    background: #FC3938;
                    box-shadow: 0px 6px 8px 0px rgba(252, 57, 56, 0.31);
                    border-radius: 4px;
                    // margin-left: 20px;
                }

                // &:before {
                //     content: "";
                //     display: none;
                //     // width: 3px;
                //     // height: 24px;
                //     // /* border-radius: 50%; */
                //     position: absolute;
                //     top: 12px;
                //     // left: -52px;
                //     // background-color: #79bbff;
                //     width: 260px;
                //     height: 36px;
                //     background: #FC3938;
                //     box-shadow: 0px 6px 8px 0px rgba(252,57,56,0.31);
                //     border-radius: 4px;

                // }
            }
        }
    }

    .article {
        border-radius: 8px;
        width: 880px;
        // background-color:#eceeef;
        // box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
        // transition: box-shadow 0.2s linear;
        // border-color: transparent;
    }
}

@media (max-width: 768px) {
    .miandiv[data-v-34009776] {
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: #f7f7f7;
    }

    .pc {
        display: none;
    }

    .phone {
        display: block !important;
    }

    .banner {
        width: 100%;
        position: relative;
        top: -10px;
        margin: 0 0 10px;
        height: 120px;
        border-radius: 8px;
        // margin-right: 0;
        object-fit: cover;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666;
        font-size: 24px;
        background: linear-gradient(89deg, #ffe3df, #e7f0f0);
    }

    .banner-box {
        width: 100%;
        // position: relative;
        // top: -10px;
        height:100px;
        border-radius: 10px;
        padding: 0 20px;
        margin-bottom: 10px;
        object-fit: cover;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #0F0F0F;
        font-size: 16px;

        // background: linear-gradient(89deg, #ffe3df, #e7f0f0);
        background: linear-gradient(340deg, #f4be9787, #f5ded326);
    }

    .container {
        // border: 1px solid  transparent;
        width: 100%;
        padding-top: 0px;
        padding-bottom: 0px;

        // background-color: #f8f8f8;
        .top {
            background-image: url('@/assets/images/myphone.png');
            /* 背景图片覆盖整个容器，不留空白 */
            background-size: 100% auto;
            /* 背景图片不平铺 */
            background-repeat: no-repeat;
            padding-bottom: 10px;
        }

        .head {
            // background: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 21px 15px 25px 15px;

            .avatar {
                display: flex;
                align-items: center;

                .avatar-container {
                    display: inline-block;
                    /* 或者使用 block，取决于你的布局需求 */
                    text-align: center;

                    /* 如果需要居中显示 */
                    .avatar {
                        width: 50px;
                        /* 设置头像的宽度 */
                        height: 50px;
                        /* 设置头像的高度 */
                        border-radius: 50%;
                        /* 设置圆角，使其看起来像圆形 */
                        object-fit: cover;
                        /* 确保图片内容被裁剪以适应容器 */
                        border: 1px solid #fff;
                        /* 添加白色边框 */
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                        /* 添加阴影以增加立体感 */
                    }
                }

                .user {
                    // width: 158px;
                    padding-left: 15px;

                    .name {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        font-size: 20px;
                        color: #333333;
                        line-height: 28px;
                        text-align: left;
                        font-style: normal;
                        width: 160px;
                        white-space: nowrap;
                        /* 禁止文本换行 */
                        overflow: hidden;
                        /* 隐藏超出部分 */
                        text-overflow: ellipsis;
                    }

                    .userHome {
                        color: #b1b3b8;
                    }

                    .text {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #333333;
                        line-height: 12px;
                        // text-align: right;
                        font-style: normal;
                        width: 170px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        cursor: pointer;
                        transition: max-height 0.3s ease;
                    }

                    .text.expanded {
                        color: #b1b3b8;
                        width: 170px;
                        text-overflow: clip;
                        max-height: 1000px;
                        overflow: initial;
                        word-wrap: break-word;
                        /* 允许长单词或URL地址换行到下一行 */
                        white-space: normal;
                        /* 或者一个足够大的值，以容纳所有文本 */
                    }
                }


            }

            .setup {
                display: flex;
                align-items: center;

                .item {
                    display: flex;
                    flex-direction: column;
                    padding: 0 8px;
                    align-items: center;
                    font-size: 14px;
                }
            }
        }

        .userCenter {}

        .content {
            // background-color: #fff;
            /* 确保图片内容被裁剪以适应容器 */
            // border: 2px solid #fff;
            /* 添加白色边框 */
            // box-shadow: 7px 10px #b3d5f794;

            margin: 0px 15px 20px 15px;
            border-radius: 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 0px 15px;

            .item {

                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-direction: column;

                .title {
                    padding-top: 9px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 12px;
                    color: #333333;
                    line-height: 12px;
                    text-align: right;
                    font-style: normal;
                }

                .right {

                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 18px;
                    color: #0F0F0F;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                }
            }

            .item-hr {
                height: 1px;
                background: #b1b3b873;
                margin: 0 15px;
            }
        }

        .trade {
            background: #FFFFFF;
            border-radius: 8px;
            /* 确保图片内容被裁剪以适应容器 */
            // border: 2px solid #fff;
            /* 添加白色边框 */
            // box-shadow: 7px 10px #b3d5f794;

            margin: 0px 15px 0 15px;
            padding: 24px 15px;

            .title {
                font-size: 14px;
                padding-left: 10px;
                padding-top: 10px;
            }

            .tradecontent {
                // margin: 14px 15px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .item {
                    padding: 0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 100%;
                    position: relative;

                    .title {
                        font-size: 12px;
                        color: #1296db;
                        padding-top: 6px;
                        padding-left: 0px;

                    }

                    .em {
                        font-style: normal;
                        position: absolute;
                        // right: 0;
                        top: -4px;
                        right: 9px;
                        // padding: 3px 5px;
                        // line-height: 1;
                        padding: 0;
                        width: 16px;
                        height: 16px;
                        line-height: 16px;
                        background: #FC3938;
                        color: #fff;
                        font-size: 10px;
                        border-radius: 50%;
                        font-family: Arial;
                        text-align: center;
                    }
                }
            }
        }

        .lishi {
            background: #fff;
            padding: 10px 20px 60px 20px;
            margin: 0 auto;
            // border-radius: 20px;
            // position: relative;
            // top: -10px;

            .goods-list {
                padding-bottom: 42px;

                .body {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(48%, 0fr));
                    grid-auto-rows: 302px;
                    grid-gap: 5px;
                }
            }
        }

    }

    :deep(.el-dialog) {
        padding-bottom: 0;
        padding-left: 0;
        padding-right: 0;
    }

    .my-header {
        color: #222;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
    }

    .dialog-footer {
        display: flex;
        align-items: center;
        width: 100%;
        border-top: 1px solid #eee;

        >div {
            width: 50%;
            height: 50px;
            font-weight: 400;
            font-size: 16px;
            color: #249FF6;
            line-height: 50px;
            text-align: center;
            font-style: normal;
        }

        >div:first-child {
            border-right: 1px solid #eee;
            color: #999;
        }
    }
}
</style>